// class PickupAvailability extends HTMLElement {
// 	constructor() {
// 		super();

// 		this.errorTemplate = this.querySelector('template');
// 		this.render(this.dataset.productVariant);
// 	}

// 	render(productVariant) {
// 		fetch(`${window.Shopify.routes.root}variants/${productVariant}?section_id=pickup-availability`)
// 			.then(response => response.text())
// 			.then(text => {
// 				const html = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
// 				this.innerHTML = html.innerHTML;
// 			})
// 			.catch(error => {
// 				this.innerHTML = this.errorTemplate ? this.errorTemplate.innerHTML : error.message;
// 				console.error(error);
// 			});
// 	}
// }

// customElements.define('pickup-availability', PickupAvailability);











//? - =========================  MODAL  ========================= -//
//? - =========================  MODAL  ========================= -//

class PickUpModal {
	constructor($pickup_modal) {

		let doc = document
		this.qsa = (s, o = doc) => o.querySelectorAll(s),
			this.qs = (s, o = doc) => o.querySelector(s)


		this.$body = document.querySelector('body')
		this.$fader = document.querySelector('.screen-fader')
		this.$pickup_modal = $pickup_modal
		this.pickup = {
			$close: document.querySelector('.pickup-modal__close'),
			$trg: document.querySelector('.pickup__seemoree')
		}

		this.controlModal()
	}











	//? - =========================  control pickup  ========================= -//
	//? - =========================  control pickup  ========================= -//
	controlModal() {
		let that = this
		function openPickupModal() {
			that.$body.classList.add('is-pickup')
		}
		function closePickupModal() {
			that.$body.classList.remove('is-pickup')
		}

		this.pickup.$trg.addEventListener('click', () => openPickupModal() )

		
		this.pickup.$close.addEventListener('click', () => closePickupModal() )

		this.$fader.addEventListener('click', () => {
			that.$body.classList.contains('is-pickup') ? closePickupModal() : null

		})
	}
}
new PickUpModal(document.querySelector('.pickup-modal'))